'use client';

import { datadogRum } from '@datadog/browser-rum';
import { hideSurvicateWhenBusy, initSurvicate, recordVirtualPageView, setVisitorTraits } from '@nerdwallet/survicate';
import { useAnalyticsPageView } from '@repo/platform-analytics/AnalyticsPageView/Context';
import { useIdentityContext } from '@repo/platform-analytics/IdentityContext';
import { env } from '@repo/platform-env';
import { useParams } from 'next/navigation';
import { useEffect } from 'react';
import { buildSurvicateCardFinderTraits } from './survicateTraits';
let survicateInitialized = false;
function reportSurvicateError(error: unknown) {
  datadogRum.addError(error instanceof Error ? error : new Error(String(error)), {
    message: 'Error initializing Survicate'
  });
}
export function SurvicateInit() {
  const {
    pageViewId,
    pageName
  } = useAnalyticsPageView();
  const {
    isLoggedIn,
    sheaId
  } = useIdentityContext();
  const params = useParams<{
    branch?: string;
    slug?: string;
    experimentDecision?: string;
  }>();
  useEffect(() => {
    if (survicateInitialized) return;
    try {
      initSurvicate({
        workspaceKey: env.NEXT_PUBLIC_SURVICATE_WORKSPACE_KEY,
        engagement: false
      });
      hideSurvicateWhenBusy();
      survicateInitialized = true;
    } catch (error) {
      reportSurvicateError(error);
    }
  }, []);
  useEffect(() => {
    if (!pageViewId) return;
    try {
      recordVirtualPageView();
      setVisitorTraits(buildSurvicateCardFinderTraits({
        pageName,
        branchSlug: typeof params.branch === 'string' ? params.branch : undefined,
        stepSlug: typeof params.slug === 'string' ? params.slug : undefined,
        isLoggedIn,
        experimentDecision: typeof params.experimentDecision === 'string' ? params.experimentDecision : undefined
      }));
    } catch (error_0) {
      reportSurvicateError(error_0);
    }
  }, [pageViewId, pageName, params.branch, params.slug, params.experimentDecision, isLoggedIn]);
  useEffect(() => {
    if (!sheaId) return;
    try {
      setVisitorTraits({
        user_id: sheaId
      });
    } catch (error_1) {
      reportSurvicateError(error_1);
    }
  }, [sheaId]);
  return null;
}